<h1 mat-dialog-title>Guest submission</h1>
<mat-dialog-content>
    <p>
        Please enter your VRChat username and authenticate using Patreon to unlock your perks
    </p>
    <mat-form-field style="width: 100%">
        <mat-label>VRChat username</mat-label>
        <input matInput type="text" placeholder="VRChat username" [(ngModel)]="vrchatUsername" />
    </mat-form-field>
    <small style="color: var(--mat-sys-on-surface-variant)">
        Please make sure to enter your username exactly as it shows up in-game. Usernames are case-sensitive.
    </small>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
    <div style="display: inline-flex; flex-direction: column; gap: 4px;">
        <button mat-flat-button (click)="authenticate()" [disabled]="vrchatUsername.length < 3 || (!pow && !powError)">
            <div style="display: flex; align-items: center;">
                <img src="/img/patreon_icon.svg" alt="Patreon" style="width: 1rem; height: 1rem; margin-right: 8px;">
                {{ pow ? 'Connect' : (powError ? 'Retry' : 'Preparing...') }}
            </div>
        </button>
        @if (!pow && !powError) {
            <app-pow-progress />
        }
    </div>
</mat-dialog-actions>